module.exports = __webpack_public_path__ + "img/44638b5.png";